<template>
  <div class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <router-link
              :to="{name: 'impressum' }"
              tag="a"
            >Impressum</router-link>
          </li>
          <li>
            <router-link
              :to="{name: 'datenschutz' }"
              tag="a"
            >Datenschutz</router-link>
          </li>
          <li>
            <router-link
              :to="{name: 'disclaimer' }"
              tag="a"
            >Disclaimer</router-link>
          </li>
        </ul>
      </nav>
      <span style="font-weight: 300;">© Ideenpioniere 2020</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>

<style scoped>
.footer {
  text-align: center;
  margin-bottom: 30px;
}
.footer .container {
  padding-top: 0px;
  padding-bottom: 0px;
}
.footer nav {
  display: table;
  height: 50px;
  margin: 0px auto;
}
.footer nav ul {
  display: table-cell;
  vertical-align: middle;
}
.footer nav ul li {
  float: left;
  color: #9bb5c2;
}
.footer nav ul li::before {
  content: "|";
  padding: 0px 5px;
}
.footer nav ul li a {
  color: var(--v-warning-base);
}
.footer nav ul li:first-child::before {
  content: "";
  padding: 0px;
}
</style>
